<template>
  <footer>
    Created by
    <a href="/" class="link">Nijat Dursunlu</a>
    | © All rights reserved
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
footer {
  background: #613cbf;
  text-align: center;
  padding: 28px 30px;
  color: white;
  font-size: 18px;
}

.link {
  text-decoration: none;
  color: crimson;
  font-weight: 600;
}
</style>